import img1 from '../../assets/images/partners/1.png'
import img2 from '../../assets/images/partners/2.png'
import img3 from '../../assets/images/partners/3.png'
import img4 from '../../assets/images/partners/4.png'
import img5 from '../../assets/images/partners/5.png'
import img6 from '../../assets/images/partners/6.png'
import img7 from '../../assets/images/partners/7.png'
import img8 from '../../assets/images/partners/8.png'
import img9 from '../../assets/images/partners/9.png'
import img10 from '../../assets/images/partners/10.png'
import img11 from '../../assets/images/partners/11.png'
import img12 from '../../assets/images/partners/12.png'
import img13 from '../../assets/images/partners/13.png'
import img14 from '../../assets/images/partners/14.png'
import img15 from '../../assets/images/partners/15.png'
import img16 from '../../assets/images/partners/16.png'
import img17 from '../../assets/images/partners/17.png'
import img18 from '../../assets/images/partners/18.png'
import img19 from '../../assets/images/partners/19.png'
import img20 from '../../assets/images/partners/20.png'
import img21 from '../../assets/images/partners/21.png'
import img22 from '../../assets/images/partners/22.png'
import img23 from '../../assets/images/partners/23.png'
import img24 from '../../assets/images/partners/24.png'
import img25 from '../../assets/images/partners/25.png'
import img26 from '../../assets/images/partners/31.png'
import img27 from '../../assets/images/partners/32.png'
import img28 from '../../assets/images/partners/28.png'
import img29 from '../../assets/images/partners/29.png'
import img30 from '../../assets/images/partners/30.png'
import img33 from '../../assets/images/partners/33.png'
export const data = [
  // {
  //   id: 1,
  //   personImage: img33,
  //   personName: "University of Windsor",
  //   link: "https://www.uwindsor.ca",
  //   socialLinks: {
  //     facebook: "//www.facebook.com",
  //     twitter: "//www.twitter.com",
  //     linkedin: "//www.linkedin.com",
  //     youtube: "//www.youtube.com",
  //   },
  // },
  {
    id: 1,
    personImage: img29,
    personName: "University of New Brunswick",
    link: "https://www.unb.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 2,
    personImage: img24,
    personName: "University of Prince Edward Island",
    link: "https://www.upei.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 3,
    personImage: img1,
    personName: "Sheridan College",
    link: "https://www.sheridancollege.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 4,
    personImage: img30,
    personName: "Trent University",
    link: "https://www.trentu.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 5,
    personImage: img9,
    personName: "Memorial University",
    link: "https://www.mun.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  // {
  //   id: 6,
  //   personImage: img26,
  //   personName: "Thompson Rivers University",
  //   link: "https://www.tru.ca",
  //   socialLinks: {
  //     facebook: "//www.facebook.com",
  //     twitter: "//www.twitter.com",
  //     linkedin: "//www.linkedin.com",
  //     youtube: "//www.youtube.com",
  //   },
  // },
  {
    id: 7,
    personImage: img25,
    personName: "University of Calgary",
    link: "https://ucalgary.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  // {
  //   id: 8,
  //   personImage: img27,
  //   personName: "University of Winnipeg",
  //   link: "https://www.uwinnipeg.ca",
  //   socialLinks: {
  //     facebook: "//www.facebook.com",
  //     twitter: "//www.twitter.com",
  //     linkedin: "//www.linkedin.com",
  //     youtube: "//www.youtube.com",
  //   },
  // },
  {
    id: 9,
    personImage: img23,
    personName: "University of Regina",
    link: "https://www.uregina.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 10,
    personImage: img8,
    personName: "Wilfrid Laurier University",
    link: "https://www.wlu.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 11,
    personImage: img3,
    personName: "Niagara University",
    link: "https://www.niagara.edu",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 12,
    personImage: img17,
    personName: "Trinity Western University",
    link: "https://www.twu.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 13,
    personImage: img21,
    personName: "University of Niagara Falls",
    link: "https://www.unfc.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 14,
    personImage: img4,
    personName: "Huron University",
    link: "https://huronu.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 15,
    personImage: img22,
    personName: "University Canada West",
    link: "https://www.ucanwest.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 16,
    personImage: img5,
    personName: "Centennial College",
    link: "https://www.centennialcollege.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 17,
    personImage: img15,
    personName: "Seneca College",
    link: "https://www.senecapolytechnic.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 18,
    personImage: img2,
    personName: "Georgian College",
    link: "https://www.georgiancollege.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 19,
    personImage: img11,
    personName: "Conestoga College",
    link: "https://www.conestogac.on.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 20,
    personImage: img12,
    personName: "Niagara College",
    link: "https://www.niagaracollege.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 21,
    personImage: img14,
    personName: "Red River College",
    link: "https://www.rrc.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 22,
    personImage: img20,
    personName: "St. Clair College",
    link: "https://www.stclaircollege.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 23,
    personImage: img6,
    personName: "Justice Institute British Columbia",
    link: "https://www.jibc.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 24,
    personImage: img18,
    personName: "Oxford International Education Group",
    link: "https://www.oxfordinternational.com",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 25,
    personImage: img10,
    personName: "Robertson College",
    link: "https://www.robertsoncollege.com",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 26,
    personImage: img16,
    personName: "Sprott Shaw College",
    link: "https://sprottshaw.com",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 27,
    personImage: img7,
    personName: "Fanshawe College",
    link: "https://www.fanshawec.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 28,
    personImage: img13,
    personName: "Northern Alberta Institute of Technology",
    link: "https://www.nait.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
  {
    id: 29,
    personImage: img19,
    personName: "Cambrian College",
    link: "https://cambriancollege.ca",
    socialLinks: {
      facebook: "//www.facebook.com",
      twitter: "//www.twitter.com",
      linkedin: "//www.linkedin.com",
      youtube: "//www.youtube.com",
    },
  },
];
